import { render, staticRenderFns } from "./UserLanguageMenu.vue?vue&type=template&id=634f5c11&scoped=true&"
import script from "./UserLanguageMenu.vue?vue&type=script&lang=js&"
export * from "./UserLanguageMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserLanguageMenu.vue?vue&type=style&index=0&id=634f5c11&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634f5c11",
  null
  
)

export default component.exports